import { render } from "./LectureVideoList.vue?vue&type=template&id=f4a1a86c&scoped=true"
import script from "./LectureVideoList.vue?vue&type=script&lang=js"
export * from "./LectureVideoList.vue?vue&type=script&lang=js"

import "./LectureVideoList.vue?vue&type=style&index=0&id=f4a1a86c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a1a86c"]])

export default __exports__